// Copyright (C) 2021 TANNER AG

export const pad = (num, size) => {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
};



// WEBPACK FOOTER //
// ./src/utils/helper.js